$(document).on("click",".zoom-btn",function() {
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    pagination: {
      el: '.product__zoom-pagination',
    },
    navigation: {
      nextEl: '.product__zoom-button.swiper-button-next',
      prevEl: '.product__zoom-button.swiper-button-prev',
    }
  });
  
   var zoom_alt = $(this).parent('.product__media').find('img').attr('alt');
   const zoomContainer = $('.product__zoom');
   var index =   $('.product__zoom-item[data-alt="'+ zoom_alt +'"]').data('swiper-slide-index');
    productZoomSlider.slideToLoop(index);
    setTimeout(() => {
      zoomContainer.addClass('open');
  }, 150);
});

/* DISABLE RIGHT CIICK FUNTION */

// document.addEventListener('contextmenu', event => event.preventDefault());

document.onkeydown = function (e) {

  // disable F12 key
  if(e.keyCode == 123) {
      return false;
  }
  
}

document.addEventListener("DOMContentLoaded", (event) => {
  window.extractFloatNumber = function(inputString) {
    const regex = /[\d,]+\.\d{2}/;
    const match = inputString.match(regex);
    if (match) {
      const floatNumber = match[0].replace(/,/g, '');
      return parseFloat(floatNumber);
    } else {
      return null;
    }
  }

  window.updateSubtotalPrice = function(){
    let subtotalPrice = 0;
    document.querySelectorAll(".updated--price").forEach(el => {
      let quantity = el.closest(".cart-item__content").querySelector(".quantity__input").value;
      if(el.querySelectorAll("span").length == 0){
        subtotalPrice = subtotalPrice + (window.extractFloatNumber(el.innerText) * quantity);
      }
      else if(el.querySelectorAll("span").length > 0){
        subtotalPrice = subtotalPrice + (window.extractFloatNumber(el.querySelector("span").innerText) * quantity);
      }
    })
    
    let updatedFormattedMoney = subtotalPrice.toLocaleString(`${Shopify.locale}-${Shopify.country}`, { style: 'currency', currency: Shopify.currency.active });
    const updatedSubtotalElement = document.querySelector(".updated--subtotal");
    if(updatedSubtotalElement){
      updatedSubtotalElement.innerText = updatedFormattedMoney;
      updatedSubtotalElement.classList.remove("hidden");
    }
  }

  if(window.location.href.includes("/cart")){
    window.updateSubtotalPrice();
  }
  
});

$(document).on('change','.cart_upsell-variant-select',function(e){
  e.preventDefault();
  var id= $(this).children("option:selected").val();
  $(this).closest('.upsell_product-container').find('.js-add-to-cart').attr('data-id',id);
  var price = $(this).children("option:selected").data('price');
  $(this).closest('.upsell_product-container').find('.upsell_price').html("+"+ price +"");
  var availability = $(this).children("option:selected").data('check');
  if(availability == 'soldout'){
    $(this).closest('.upsell_product-container').find('.js-add-to-cart').addClass('soldout');
  }else{
    $(this).closest('.upsell_product-container').find('.js-add-to-cart').removeClass('soldout');
  }
})
